import Vue from 'vue';
import { formatCurrency } from './services/currency.service';

Vue.use({
  install (Vue) {
    /**
     * Currency filter with hybrid approach:
     * - Automatically reads currency from store data object via Vuex
     * - Allows explicit currency code override
     * - Falls back to USD if store not available
     *
     * Usage:
     *   {{ price | currency }}                    // Auto from store
     *   {{ price | currency(true, false) }}       // Auto with params
     *   {{ price | currency(true, false, 'EUR') }} // Explicit currency
     *
     * @param {number} value - The numeric value to format
     * @param {boolean} showDec - Whether to show decimal places (default: true)
     * @param {boolean} showZero - Whether to show zero values (default: false)
     * @param {string} currencyCode - Optional ISO 4217 currency code (e.g., 'USD', 'EUR')
     * @returns {string|null} Formatted currency string
     */
    const currency = function(value, showDec = true, showZero = false, currencyCode = null) {
      // Return null if value is falsy and showZero is false
      if (!value && !(showZero && value === 0)) {
        return null;
      }

      // Try to get currency code if not explicitly provided
      let finalCurrencyCode = currencyCode;
      if (!finalCurrencyCode) {
        try {
          // Access Vuex store from Vue prototype (set in main.js)
          const vueStore = Vue.prototype.$store;

          if (vueStore && vueStore.getters) {
            // Use the dedicated getCurrencyCode getter (more efficient than accessing whole store object)
            // Vuex getters are cached/memoized, so this is performant
            finalCurrencyCode = vueStore.getters['getCurrencyCode'] || vueStore.getters['storeDetail/getCurrencyCode'];
          }
        } catch (e) {
          // Silently fail if store is not available
        }
      }

      // Fall back to USD if no currency code found
      finalCurrencyCode = finalCurrencyCode || 'USD';

      // Use the currency service to format the value
      return formatCurrency(value, finalCurrencyCode, showDec, showZero);
    }
    const phone = (phone) => {
      if (!phone)
        return phone
      return phone.replace(/[^0-9]/g, '')
                  .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    }
    const capatalize = (value) => {
      if (!value)
        return value

      return value.toLowerCase()
                  .split(/ /g)
                  .map(word => `${word.substring(0,1).toUpperCase()}${word.substring(1)}`)
                  .join(" ");
    }
    const comma = (num) => {
      return num ? num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : num
    }

    const readableEnum = (enumVal) => {
      return enumVal ? capatalize((''+enumVal).toLowerCase().replace(/_/g, ' ')) : enumVal
    }

    // Gross way of declaring filters in a way that they are accessable in vuex modules
    // Note: In Vuex modules, pass currency code explicitly since this.$store is not available
    Vue.prototype.$currency = (value, showDec = true, showZero = false, currencyCode = null) => {
      // Auto-detect currency code if not provided
      let finalCurrencyCode = currencyCode;
      if (!finalCurrencyCode) {
        try {
          const vueStore = Vue.prototype.$store;
          if (vueStore && vueStore.getters) {
            finalCurrencyCode = vueStore.getters['getCurrencyCode'] || vueStore.getters['storeDetail/getCurrencyCode'];
          }
        } catch (e) {
          // Silently fail if store is not available
        }
      }
      finalCurrencyCode = finalCurrencyCode || 'CAD';
      return formatCurrency(value, finalCurrencyCode, showDec, showZero);
    }
    Vue.prototype.$phone = phone
    Vue.prototype.$capatalize = capatalize
    Vue.prototype.$comma = comma
    Vue.prototype.$readableEnum = readableEnum

    Vue.filter('currency', currency);
    Vue.filter('phone', phone);
    Vue.filter('capatalize', capatalize);
    Vue.filter('comma', comma);
    Vue.filter('readableEnum', readableEnum);
  }
})

// Vue.filter('currency', function (value, showDec = true) {
//   return value ? '$' + (showDec ? value.toFixed(2) : value) : '$0.00'
// });
// Vue.filter('phone', function (phone) {
//   if (!phone)
//     return phone
//   return phone.replace(/[^0-9]/g, '')
//               .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
// });

// Vue.filter('capatalize', function (value) {
//   if (!value)
//     return value
//
//   return value.toLowerCase()
//               .split(/ /g)
//               .map(word => `${word.substring(0,1).toUpperCase()}${word.substring(1)}`)
//               .join(" ");
// });
//
// Vue.filter('comma', function (num) {
//   return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
// });
